export default __webpack_public_path__ + "static/media/preface 1.05574675.png";